import { Validator } from "../validator"

enum EmailError {
    PATTERN = `errors.email`,
    EMPTY = `errors.required`,
}

const PATTERN = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i

class EmailValidator implements Validator<string, EmailError> {
    validate(value: string): EmailError | undefined {
        if (value === ``) {
            return EmailError.EMPTY
        }

        if (!PATTERN.test(value)) {
            return EmailError.PATTERN
        }
    }
}

export default EmailValidator
export { EmailError }
